import React from "react";
import { Box, Text, type SpaceProps } from "@chakra-ui/react";
import { Link } from "ui/link";
import { desktopOnlyDisplay } from "utils";
import Balancer from "react-wrap-balancer";

export function OldVersionAlert({
  title,
  currentVersionSlug,
  ...props
}: { title: string; currentVersionSlug: string } & SpaceProps) {
  return (
    <Box bg="new.yellow.50" borderRadius="base" textAlign="center" p={{ base: "smaller", md: "small" }} {...props}>
      <Balancer>
        <Text textStyle="caption1" fontWeight="semibold" lineHeight="1.7">
          This version of Hightouch&apos;s {title} is no longer in effect.{" "}
          <Box as="br" display={desktopOnlyDisplay()} />
          View the current {title}{" "}
          <Link variant="inlineDark" href={`/${currentVersionSlug}`}>
            here
          </Link>
          .
        </Text>
      </Balancer>
    </Box>
  );
}
